import { render, staticRenderFns } from "./serviceAgreementDetails.vue?vue&type=template&id=58e0637e&scoped=true"
var script = {}
import style0 from "./serviceAgreementDetails.vue?vue&type=style&index=0&id=58e0637e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0637e",
  null
  
)

export default component.exports